module.exports = __webpack_public_path__ + "static/media/google_plus_logo.7551c74a.png";